module.exports = __webpack_public_path__ + "img/gnjs1.063dc13c.png";